// The tier-cookie wire header, used in both directions (request = client opt-in, response =
// mint-status echo), so one constant backs both header maps.
// KEEP_IN_SYNC weavy/core/src/shared/tier-cookie/tier-cookie.util.ts (TIER_COOKIE_CLIENT_HEADER)
export const TIER_COOKIE_HEADER = 'x-wv-tier-cookie';

// Request-direction sentinel: the server only checks the header is present, not its value.
export const TIER_COOKIE_OPT_IN_VALUE = '1';

/**
 * Response-direction marker set on a uid-mismatch 403, so the client retries once, recording the
 * re-minted cookie only when the response also carries the `issued` echo.
 * KEEP_IN_SYNC weavy/core/src/shared/tier-cookie/tier-cookie.util.ts (TIER_COOKIE_MISMATCH_HEADER)
 */
export const TIER_COOKIE_MISMATCH_HEADER = 'x-wv-tier-mismatch';

export const OUTGOING_HEADER_NAMES = {
  APP_VERSION: 'x-app-version',
  APP_RECIPE_ID: 'x-app-recipeid',
  TIER_COOKIE: TIER_COOKIE_HEADER,
} as const;

export const INCOMING_HEADER_NAMES = {
  SUPPORTED_APP_VERSION: 'x-supported-app-version',
  /** KEEP_IN_SYNC weavy/core Consts.FIGMA_REST_API_REQUEST_ID_HEADER_NAME */
  FIGMA_REST_API_REQUEST_ID: 'x-figma-rest-api-request-id',
  TIER_COOKIE: TIER_COOKIE_HEADER,
  TIER_COOKIE_MISMATCH: TIER_COOKIE_MISMATCH_HEADER,
} as const;

/** KEEP_IN_SYNC weavy/core/src/shared/tier-cookie/tier-cookie.util.ts (TIER_COOKIE_ISSUED) */
export const TIER_COOKIE_ISSUED_STATUS = 'issued';
